<template>
    <div class="contenedor">
        <div>
            <b-row>
            <b-col sm="6">
                <span class="titulo">Producto A: <span class="productoNom">{{ producto1.nombre }}</span></span>
            </b-col>
            <b-col sm="6">
                <span class="titulo">Producto B: <span class="productoNom">{{ producto2.nombre }}</span></span>
            </b-col>
        </b-row>
            <b-card class="mt-3">
                <div slot="header">
                    <strong><center>{{ preguntas[i].pregunta }}</center></strong>
                </div>                
                <b-row v-if="preguntas[i].codigo.indexOf('verificar-seccion') != -1" class="mb-5">
                    <b-col sm="6" v-if="producto1.adjuntos.length" class="d-flex flex-column align-items-end">
                        <label>Adjunto del producto a</label>
                        <b-button variant="secondary" class="w-50" @click="visualizarFds(producto1.adjuntos[0].adjunto)">
                            Visualizar FDS
                        </b-button>
                    </b-col>
                    <b-col sm="6" class="d-flex flex-column" v-else> 
                        <label>Adjunto producto a</label>  
                        <b-form-file
                            @change="obtenerAdjunto($event, 1)"
                            class="w-50"
                            type="file"
                            accept=".csv,.pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword"
                        >
                        </b-form-file>
                        <div>
                            <b-button variant="primary" class="mt-3 float-right" @click="guardarAdjunto(1)" :disabled="!adjuntoProd1">
                                <i class="fa fa-save"></i>
                                Guardar
                            </b-button>
                        </div>
                    </b-col>
                    <b-col sm="6" v-if="producto2.adjuntos.length" class="d-flex flex-column">
                        <label>Adjunto del producto b</label>
                        <b-button variant="secondary" class="w-50" @click="visualizarFds(producto2.adjuntos[0].adjunto)">
                            Visualizar FDS
                        </b-button>
                    </b-col>
                    <b-col sm="6" class="d-flex flex-column" v-else> 
                        <label>Adjunto producto b</label>  
                        <b-form-file
                            @change="obtenerAdjunto($event, 2)"
                            class="w-50"
                            type="file"
                            accept=".csv,.pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword"
                        >
                        </b-form-file>
                        <div>
                            <b-button variant="primary" class="mt-3 float-right" @click="guardarAdjunto(2)" :disabled="!adjuntoProd2">
                                <i class="fa fa-save"></i>
                                Guardar
                            </b-button>
                        </div>
                    </b-col>
                    <b-modal hide-footer title="" scrollable ref="modal_fds" size="xl">
                        <div>
                            <b-embed type="iframe" :src="fdsUrl" allowfullscreen></b-embed>
                        </div>
                    </b-modal>
                    <hr />
                </b-row>
                <b-row v-if="preguntas[i].tipo_pregunta === 'cerrada'">                    
                    <b-col sm="6">                        
                        <b-button variant="primary" size="lg" class="float-right w-50" 
                        @click="guardarRespuesta(preguntas[i].codigo, preguntas[i].pregunta_si, 1)">
                            Si
                        </b-button>
                    </b-col>
                    <b-col sm="6">
                        <b-button variant="info" size="lg" class="float-left w-50" 
                        @click="guardarRespuesta(preguntas[i].codigo, preguntas[i].pregunta_no, 0)">
                            No
                        </b-button>
                    </b-col>
                </b-row>
                <div v-else>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group>
                                <label>
                                    Ph del producto a
                                </label>
                                <b-form-input 
                                    type="number"
                                    step="0.1"
                                    min="0"
                                    max="14"
                                    name="producto1_ph"
                                    id="producto1_ph"
                                    v-model="producto1_ph"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group>
                                <label>
                                    Ph del producto b
                                </label>
                                <b-form-input 
                                    type="number"
                                    step="0.1"
                                    min="0"
                                    max="14"
                                    name="producto2_ph"
                                    id="producto2_ph"
                                    v-model="producto2_ph"
                                />
                            </b-form-group>
                        </b-col>                 
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-button variant="primary" class="float-right" :disabled="!producto1_ph || !producto2_ph" @click="continuarPh">
                                Siguiente
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-card>
        </div>               
        <b-row class="d-flex justify-content-between"> 
            <b-col sm="10">
                <b-button @click="regresarPaso" class="mr-2" v-if="i !== 0 || (!this.producto1.id || !this.producto2.id)">
                    Anterior
                </b-button>
                <b-button @click="$emit('volverMatriz')">
                    Cancelar
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import loader from './../../containers/loader'

export default {
    name:'preguntas',
    props:['admin'],
    data(){
        return{
            loading: false,
            pasoActual: 3,
            i: 0,
            producto1_ph: '',
            producto2_ph: '',
            ambosBases: false,
            ambosAcidos: false,
            fdsUrl: '',
            adjuntoProd1: '',
            adjuntoProd2: ''
        };
    },
    components: {
        loader
    },
    watch: {
        producto1_ph: function(newValue,oldValue) {
            
            if (newValue > 14 || newValue < 0 || newValue == '00' || newValue.indexOf('e') != -1) {
                this.$nextTick(() => {
                    this.producto1_ph = oldValue;
                })
            }
        },
        producto2_ph: function(newValue,oldValue) {
            
            if (newValue > 14 || newValue < 0 || newValue == '00' || newValue.indexOf('e') != -1) {
                this.$nextTick(() => {
                    this.producto2_ph = oldValue;
                })
            }
        }
    },
    computed:{
        ...mapState('matrizCompatibilidad', [
            'producto1',
            'producto2',
            'preguntas',
            'compatibilidad_un'
        ]),
    },
    async created() {
        this.load(true);
        await this.validarSiguientePregunta(0);
        this.load(false);
    },
    methods:{
        async guardarAdjunto(n) {
            if (n == 1 && this.adjuntoProd1) {
                let data = new FormData();
                data.append('producto', n);
                data.append('adjunto', this.adjuntoProd1);
                this.load(true);
                await this.guardarAdjuntoMatriz(data);
                this.load(false);
            } else if (n == 2 && this.adjuntoProd2) {
                this.load(true);
                let data = new FormData();
                data.append('producto', n);
                data.append('adjunto', this.adjuntoProd2);
                await this.guardarAdjuntoMatriz(data);
                this.load(false);
            }
        },
        obtenerAdjunto(e, n) {
            if (n == 1) {
                this.adjuntoProd1 = e.target.files[0];
            } else {
                this.adjuntoProd2 = e.target.files[0];
            }
        },
        continuarPh() {
            if (this.producto1_ph < 7 && this.producto2_ph < 7) {
                this.ambosAcidos = true;
            } else if (this.producto1_ph > 7 && this.producto2_ph > 7) {
                this.ambosBases = true;
            }
            this.i++;
        },
        async visualizarFds(url) {
            this.fdsUrl = process.env.VUE_APP_API_URL + 'storage/files/'+url;
            this.$refs.modal_fds.show();
        },
        async guardarRespuesta(codigo, sigPregunta, n) {
            this.preguntas[this.i].respuesta = n;
            
            if (!sigPregunta) {
                let data = { 
                    producto1: this.producto1, 
                    producto2: this.producto2, 
                    preguntas: this.preguntas, 
                    compatibilidad_un: this.compatibilidad_un,
                    producto1_ph: this.producto1_ph,
                    producto2_ph: this.producto2_ph 
                }

                this.load(true);
                await this.guardarComparativaProductos(data);
                this.load(false);
            } else if (sigPregunta && this.preguntas.findIndex(p => p.codigo == sigPregunta.codigo) != -1) {
                this.i = this.preguntas.findIndex(p => p.codigo == sigPregunta.codigo);
                this.load(true);
                await this.validarSiguientePregunta(this.i);
                this.load(false);
            }
        },
        async validarSiguientePregunta(n) {    
            let data = { 
                producto1: this.producto1, 
                producto2: this.producto2, 
                preguntas: this.preguntas, 
                compatibilidad_un: this.compatibilidad_un,
                producto1_ph: this.producto1_ph,
                producto2_ph: this.producto2_ph 
            }

            if (this.preguntas[n].automatica === true) {                
                if ((this.preguntas[n].respuesta === 0 && this.preguntas[n].resultado_no != '') || (this.preguntas[n].respuesta === 1 && this.preguntas[n].resultado_si != '')) {
                    this.load(true);
                    await this.guardarComparativaProductos(data);
                    this.load(false);
                } 
                this.i++;
                this.load(true);
                await this.validarSiguientePregunta(this.i);
                this.load(true);
            } else {
               
                if (this.preguntas[n].codigo == 'ambos-acidos') {
                    if ((this.producto1_ph <= 7 && this.producto1_ph >= 7) || (this.producto1_ph >= 7 && this.producto2_ph <= 7)) {
                        this.preguntas[n].respuesta = 0;
                        this.load(true);
                        await this.guardarComparativaProductos(data);
                        this.load(false);
                    }
                    this.preguntas[n].respuesta = this.ambosAcidos;
                    this.i = this.ambosAcidos ? this.preguntas.findIndex(p => p.codigo == this.preguntas[n].pregunta_si.codigo) : this.preguntas.findIndex(p => p.codigo == this.preguntas[n].pregunta_no.codigo);
                } else if (this.preguntas[n].codigo == 'ambos-bases') {
                    this.preguntas[n].respuesta = this.ambosBases;
                    this.i = this.ambosBases ? this.preguntas.findIndex(p => p.codigo == this.preguntas[n].pregunta_si.codigo) : this.preguntas.findIndex(p => p.codigo == this.preguntas[n].pregunta_no.codigo);
                }
            }
        },
        regresarPaso() {
          if (this.i !== 0) {
            this.i--;
          } else {
            this.setPaso(2);
          }
        },   
        ...mapActions('adjuntos', [
            'getListadoAdj'
        ]),
        ...mapActions('matrizCompatibilidad', [
          'validarUNSgaProductos',
          'validarPregunta',
          'guardarComparativaProductos',
          'guardarAdjuntoMatriz'
        ]),
        ...mapActions('sga', [
            'getJsonSga'
        ]),
        ...mapMutations('dashboard', [
            'load'
        ]),
        ...mapMutations('matrizCompatibilidad', [
            'setModalMatriz',
            'setPaso'
        ])
    }
}
</script>
<style scoped>
.productoNom {
    font-size: 12pt;
}
.productoNom {
  font-size: 11pt;
}
.titulo {
  font-size: 13pt;
}
</style>
